"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VAChatService = void 0;
class VAChatService {
    constructor() {
        this.send = async (body) => {
            const location = window.location.href;
            let subdomain = 'wgvbmart-18.qa';
            if (/^https?:\/\/www\.ameriprise\.com\//.test(location)) {
                subdomain = 'wgvbmart-18';
            }
            else if (/^https?:\/\/www-preprod\.ameriprise\.com\//.test(location)) {
                subdomain = 'wgvbmart-18-b';
            }
            const sanitizedBody = this.sanitizePayload(body);
            return fetch(`https://${subdomain}.ameriprise.com/smc.svc/sendPubUserVAChatMessage`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    consumer: 'id=A0056099-8CC7YJYS05J7L89Y;type=WEB'
                },
                body: JSON.stringify(sanitizedBody)
            })
                .then(resp => {
                return resp.json();
            })
                .catch(() => {
                throw new Error(`VAChatService send failed.`);
            });
        };
    }
    /**
     * Extracts only the allowed fields from the payload to prevent
     * unintended data from being transmitted (CWE-201 mitigation).
     */
    sanitizePayload(body) {
        return {
            userId: body.userId,
            userCtx: body.userCtx,
            msgType: body.msgType,
            usrEmailAddr: body.usrEmailAddr,
            vaChatId: body.vaChatId,
            val: body.val
        };
    }
}
exports.VAChatService = VAChatService;
